import React from 'react'
import { Trans } from '@lingui/macro'

import { staticLinks } from '../../../../shared/linkBuilder'
import IconMagicWand from '../../components/common/icon/IconMagicWand'
import IconKey from '../../components/common/icon/IconKey'
import IconEnvelope from '../../components/common/icon/IconEnvelope'
import IconEnergy from '../../components/common/icon/IconEnergy'
import IconPeople from '../../components/common/icon/IconPeople'
import { useFeatureFlags } from '../../app/hooks/useFeatureFlags'
import { AdminOnlyAllowed } from '../../components/common/AdminOnlyAllowed'
import { Tabs, Tab, TabList } from 'front-end/src/components'
import { navigateTo } from 'front-end/src/app/util/appHistory'
import { useLocation } from 'react-router-dom'

const AccountPageTabs = () => {
  const { featureFlags } = useFeatureFlags()

  // TODO: Find a more general way how to treat defaultIndex for Chakras Tabs/Tab
  const getCurrentTab = () => {
    const { pathname } = useLocation()
    switch (pathname) {
      case staticLinks.accountSettings: {
        return 0
      }
      case staticLinks.accountAuthenticationOptions: {
        return 1
      }
      case staticLinks.accountNotifications: {
        return 2
      }

      case staticLinks.accountProvisioning: {
        return 3
      }

      case staticLinks.accountCampaigns: {
        return 4
      }
      case staticLinks.accountCustomTranslations: {
        return 5
      }
      default: {
        return 0
      }
    }
  }

  return (
    <>
      <Tabs defaultIndex={getCurrentTab()}>
        <TabList borderBottom={0}>
          <Tab
            onClick={() => navigateTo(staticLinks.accountSettings)}
            data-test="CustomiseTab"
          >
            <IconMagicWand mr="8px" />
            <Trans>Customise</Trans>
          </Tab>
          <Tab
            onClick={() => navigateTo(staticLinks.accountAuthenticationOptions)}
            isSelected={true}
            data-test="AuthenticationTab"
          >
            <IconKey mr="8px" />
            <Trans>Authentication</Trans>
          </Tab>
          <Tab onClick={() => navigateTo(staticLinks.accountNotifications)}>
            <IconEnvelope mr="8px" /> <Trans>Notifications</Trans>
          </Tab>
          <Tab onClick={() => navigateTo(staticLinks.accountProvisioning)}>
            <IconPeople mr="8px" />
            <Trans>Provisioning</Trans>
          </Tab>
          {featureFlags?.campaigns && (
            <AdminOnlyAllowed>
              <Tab onClick={() => navigateTo(staticLinks.accountCampaigns)}>
                <IconEnergy mr="8px" />
                <Trans>Campaigns</Trans>
              </Tab>
            </AdminOnlyAllowed>
          )}

          {featureFlags?.custom_i18n && (
            <AdminOnlyAllowed>
              <Tab
                onClick={() =>
                  navigateTo(staticLinks.accountCustomTranslations)
                }
              >
                <IconEnergy mr="8px" />
                <Trans>Custom translations</Trans>
              </Tab>
            </AdminOnlyAllowed>
          )}
        </TabList>
      </Tabs>
    </>
  )
}

export default AccountPageTabs
